// src/pages/approvals/ShopRequests.js

import React, { useState } from "react";
import ShopList from "../../components/ShopList";

const FILTERS = [
    {
        id: "all",
        label: "All Requests",
    },
    {
        id: "registration",
        label: "New Registrations",
    },
    {
        id: "claim",
        label: "Ownership Claims",
    },
];

export default function ShopRequests() {
    const [activeFilter, setActiveFilter] = useState("all");

    return (
        <div>
            <div style={{ marginBottom: 18 }}>
                <h2 style={{ margin: 0 }}>
                    Shop Requests
                </h2>

                <div
                    style={{
                        color: "#857969",
                        fontSize: 13,
                        marginTop: 4,
                    }}
                >
                    Approve or reject new Op Shop registrations and ownership claims.
                </div>
            </div>

            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 8,
                    marginBottom: 18,
                }}
            >
                {FILTERS.map((filter) => {
                    const selected =
                        activeFilter === filter.id;

                    return (
                        <button
                            key={filter.id}
                            type="button"
                            onClick={() =>
                                setActiveFilter(filter.id)
                            }
                            style={{
                                border: selected
                                    ? "1px solid #6b5c3f"
                                    : "1px solid #ddd3c1",

                                background: selected
                                    ? "#6b5c3f"
                                    : "#ffffff",

                                color: selected
                                    ? "#ffffff"
                                    : "#6b5c3f",

                                padding: "8px 14px",
                                borderRadius: 999,
                                fontSize: 12,
                                fontWeight: 700,
                                cursor: "pointer",
                            }}
                        >
                            {filter.label}
                        </button>
                    );
                })}
            </div>

            <ShopList
                requestFilter={activeFilter}
                showRequestBadges
            />
        </div>
    );
}